import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';

/**
 * The pill tab bar used for Overview/Geo, the channel sub-tabs and the Board/List switch.
 * `items`: [{ value, label, count }]
 */
export default function SegmentedTabs({ items, value, onChange, dense = false, sx }) {
  return (
    <Box
      sx={{
        display: 'inline-flex',
        gap: '4px',
        background: 'var(--card)',
        border: '1px solid var(--border)',
        borderRadius: '12px',
        p: dense ? '3px' : '4px',
        boxShadow: 'var(--shadow)',
        maxWidth: '100%',
        overflowX: 'auto',
        ...sx,
      }}
    >
      {items.map((it) => {
        const on = value === it.value;
        return (
          <ButtonBase
            key={it.value}
            onClick={() => onChange(it.value)}
            sx={{
              px: dense ? '14px' : '20px',
              py: dense ? '6px' : '9px',
              borderRadius: '9px',
              fontFamily: 'var(--mono)',
              fontSize: 12,
              letterSpacing: '.06em',
              textTransform: 'uppercase',
              whiteSpace: 'nowrap',
              gap: 1,
              color: on ? '#fff' : 'var(--ink-2)',
              background: on ? 'var(--side)' : 'transparent',
              '&:hover': { background: on ? 'var(--side)' : 'var(--card-2)' },
            }}
          >
            {it.label}
            {it.count != null && (
              <Box
                component="span"
                sx={{
                  fontFamily: 'var(--disp)',
                  fontSize: 11,
                  background: on ? 'rgba(255,255,255,.18)' : 'rgba(0,0,0,.08)',
                  color: on ? '#fff' : 'inherit',
                  px: '7px',
                  borderRadius: '20px',
                }}
              >
                {it.count}
              </Box>
            )}
          </ButtonBase>
        );
      })}
    </Box>
  );
}
